export default (...msgs) => (context) => console.log(...msgs, context);
export const error = (...msgs) => (context) => console.error(...msgs, context);
export const info = (...msgs) => (context) => console.info(...msgs, context);
//# sourceMappingURL=log.js.map